import { Button, Grid2 } from '@mui/material';
import React from 'react';
import { useCommandsModalContext } from '../CommandsModalContext';

function BreakerSection() {
  const { sendCommand } = useCommandsModalContext();

  const handleClickEnable = () => sendCommand('OpenBreaker');
  const handleClickDisable = () => sendCommand('CloseBreaker');

  return (
    <Grid2 container spacing={2}>
      <Grid2
        size={{ xs: 4 }}
        sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}
      >
        AC Breaker:
      </Grid2>
      <Grid2 size={{ xs: 8 }}>
        <Button variant='contained' onClick={handleClickEnable}>
          Open Breaker
        </Button>
        <Button variant='contained' sx={{ ml: 2 }} onClick={handleClickDisable}>
          Close Breaker
        </Button>
      </Grid2>
    </Grid2>
  );
}

export default BreakerSection;
